import * as React from 'react';
import { observable, makeObservable } from 'mobx';
import { NotFoundPage } from '../../../mainv2/containers/common/NotFoundPage';
import { LoaderRow } from '../../components/atoms/layout/LoaderRow';
import { observer } from 'mobx-react';
import { PracticalSectionPageState } from './states/PracticalSectionPageState';
import { ExamPracticalSectionView } from '../../components/organisms/exam_sections/ExamPracticalSectionView';
import { withNavigation } from '../../components/hocs/withNavigation';
import { NavigationSpecs } from '../../states/NavigationState';
import './practicalSectionPage.module.scss';
import { authenticated } from '../../components/hocs/authenticated';
import { BreadCrumb } from '../breadcrumb/BreadCrumb';
import { Page } from '../../components/atoms/layout/Page';
import { V3Routes } from '../../routes';

type Props = {
  match: {
    params: {
      sectionId: string;
    };
  };
};

export const PracticalSectionPage = authenticated(
  withNavigation(NavigationSpecs.side())(
    observer(
      class PracticalSectionPage extends React.Component<Props> {
        pageState = new PracticalSectionPageState();

        constructor(props: Props) {
          super(props);

          makeObservable(this, {
            pageState: observable,
          });
        }

        componentDidMount(): void {
          const sectionId = Number(this.props.match.params.sectionId);
          this.pageState.init(sectionId);
        }

        render() {
          const { section } = this.pageState;

          if (section.loading && section.isEmpty()) {
            return <LoaderRow />;
          }

          if (section.isNotFound()) {
            return <NotFoundPage entityType="課題" />;
          }
          const sec = section.get();
          const breadCrumbItems = [{ text: sec.course.title, to: V3Routes.course(sec.course.id) }, { text: sec.title }];

          return (
            <Page styleName="practical-section-page">
              <BreadCrumb items={breadCrumbItems} hasHome />
              <div styleName="view-wrapper">
                <ExamPracticalSectionView section={sec} />
              </div>
            </Page>
          );
        }
      }
    )
  )
);
